import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { resolveImg } from "@/lib/api";

const links = [
  { label: "Inicio", href: "#inicio" },
  { label: "Catálogo", href: "#catalogo" },
  { label: "Resultados", href: "#resultados" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Contacto", href: "#contacto" },
];

export const Navbar = ({ content }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-sand/80 backdrop-blur-xl border-b border-forest-900/10 py-3" : "py-5"
      }`}
    >
      <nav className="max-w-[1440px] mx-auto px-6 md:px-12 flex items-center justify-between">
        <a href="#inicio" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={resolveImg(content.logo_url)} alt={content.brand_name} className="h-10 w-10 object-contain rounded-full" />
          <span className={`font-serif text-lg tracking-tight transition-colors ${scrolled ? "text-forest-900" : "text-forest-900"}`}>
            {content.brand_name}
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="text-sm font-medium text-forest-800 hover:text-terracotta-500 transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-terracotta-500 group-hover:w-full transition-all duration-300" />
            </a>
          ))}
          <a
            href={`https://wa.me/${content.whatsapp_number}?text=${encodeURIComponent(content.whatsapp_message)}`}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-whatsapp-btn"
            className="rounded-full bg-forest-900 text-sand px-5 py-2.5 text-sm font-semibold hover:bg-terracotta-500 transition-colors"
          >
            Hacer Pedido
          </a>
        </div>

        <button data-testid="mobile-menu-btn" className="md:hidden text-forest-900" onClick={() => setOpen(true)}>
          <Menu size={26} />
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 bg-forest-900 text-sand flex flex-col p-8 md:hidden"
          >
            <div className="flex justify-end">
              <button data-testid="mobile-close-btn" onClick={() => setOpen(false)}><X size={30} /></button>
            </div>
            <div className="flex flex-col gap-6 mt-10">
              {links.map((l) => (
                <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="font-serif text-3xl">
                  {l.label}
                </a>
              ))}
              <a
                href={`https://wa.me/${content.whatsapp_number}?text=${encodeURIComponent(content.whatsapp_message)}`}
                target="_blank" rel="noreferrer"
                className="mt-4 rounded-full bg-terracotta-500 text-white px-6 py-3 text-center font-semibold"
              >
                Hacer Pedido por WhatsApp
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
